const fs = require("fs");
const path = require("path");

const cacheDir = "cache-static-data";
const cache = {};

const cacheAllStaticData = async ({ fileName }) => {
  const cachePath = path.join(path.resolve(cacheDir,   fileName + ".json"));
  const getCachedData = () => {
    let cachedData;
    try {
      cachedData = JSON.parse(fs.readFileSync(cachePath, "utf8"));
    } catch (error) {
      console.error("cache not initialized");
    }
    return cachedData;
  };

  // read cache
  let cachedData = getCachedData();
  if (cachedData) {
    const result = { data: { content: cachedData } };
    cache[fileName] = result;
    return result;
  }
};

module.exports =  cacheAllStaticData ;
